module.exports = {
	"contractName": "Instance",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "password",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "infoNum",
			"outputs": [
				{
					"name": "",
					"type": "uint8"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "theMethodName",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"name": "_password",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "info",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "pure",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "info1",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "pure",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "param",
					"type": "string"
				}
			],
			"name": "info2",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "pure",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "info42",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "pure",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "method7123949",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "pure",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "passkey",
					"type": "string"
				}
			],
			"name": "authenticate",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "getCleared",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "74:25:16:-;;;-1:-1:-1;;74:25:16;97:2;74:25;;;103:65;26:1205;103:65;;26:1205;103:65;;;;;;;;;;;;;;;;;:::i;:::-;-1:-1:-1;172:28:16;;;-1:-1:-1;;172:28:16;;;222:74;5:2:-1;;;;30:1;27;20:12;5:2;222:74:16;;;;;;;;;;;;;;;;;271:20;;;;:8;;:20;;;;;:::i;:::-;;222:74;26:1205;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;26:1205:16;;;-1:-1:-1;26:1205:16;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;",
	"deployedSourceMap": "26:1205:16:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;523:245;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;523:245:16;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;523:245:16;;-1:-1:-1;523:245:16;;-1:-1:-1;;;;;;;523:245:16;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:100:-1;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;523:245:16;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;48:22;;8:9:-1;5:2;;;30:1;27;20:12;5:2;48:22:16;;;;772:112;;8:9:-1;5:2;;;30:1;27;20:12;5:2;772:112:16;;;;300:104;;8:9:-1;5:2;;;30:1;27;20:12;5:2;300:104:16;;;;1155:74;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1155:74:16;;;;;;;;;;;;;;;;;;;;;;1020:131;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;1020:131:16;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;1020:131:16;;-1:-1:-1;1020:131:16;;-1:-1:-1;;;;;;;1020:131:16;;;74:25;;8:9:-1;5:2;;;30:1;27;20:12;5:2;74:25:16;;;;;;;;;;;;;;;;;;;;;;;408:111;;8:9:-1;5:2;;;30:1;27;20:12;5:2;408:111:16;;;;888:128;;8:9:-1;5:2;;;30:1;27;20:12;5:2;888:128:16;;;;103:65;;8:9:-1;5:2;;;30:1;27;20:12;5:2;103:65:16;;;;523:245;611:18;;;;;;;;;;;;;;;;591:16;;573:6;;601:5;;611:18;;591:16;;;;;611:18;591:16;36:153:-1;66:2;58:11;;36:153;;176:10;;164:23;;-1:-1;;139:12;;;;98:2;89:12;;;;114;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;591:16:16;;;;;;;;;;;;;;;;:38;;;;587:146;;;639:87;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;587:146;-1:-1:-1;738:25:16;;;;;;;;;;;;;;;;;523:245;;;;:::o;48:22::-;;;;;;;;;;;;;;;-1:-1:-1;;48:22:16;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;772:112::-;825:54;;;811:6;825:54;;;;;;;;;;;;;;;;;;;;772:112;:::o;300:104::-;351:48;;;337:6;351:48;;;;;;;;;;;;;;;;;;;;300:104;:::o;1155:74::-;1217:7;;;;1155:74;:::o;1020:131::-;1107:8;1097:19;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;1097:19:16;;;;;;;;1075:18;;1097:19;;-1:-1:-1;1085:7:16;;-1:-1:-1;1097:19:16;;1075:18;;;;;1097:19;1075:18;36:153:-1;66:2;58:11;;36:153;;176:10;;164:23;;-1:-1;;139:12;;;;98:2;89:12;;;;114;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;1075:18:16;;;;;;;;;;;;;;;;:41;;;;1071:76;;;1126:7;:14;;-1:-1:-1;;1126:14:16;1136:4;1126:14;;;1071:76;1020:131;:::o;74:25::-;;;;;;:::o;408:111::-;460:54;;;446:6;460:54;;;;;;;;;;;;;;;;;;;;408:111;:::o;888:128::-;948:63;;;934:6;948:63;;;;;;;;;;;;;;;;;;;;888:128;:::o;103:65::-;;;;;;;;;;;;;;-1:-1:-1;;103:65:16;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;",
	"source": "pragma solidity ^0.4.18;\n\ncontract Instance {\n  string public password;\n  uint8 public infoNum = 42;\n  string public theMethodName = \"The method name is method7123949.\";\n  bool private cleared = false;\n\n  // constructor\n  function Instance(string _password) public {\n    password = _password;\n  }\n\n  function info() public pure returns (string) {\n    return \"You will find what you need in info1().\";\n  }\n\n  function info1() public pure returns (string) {\n    return 'Try info2(), but with \"hello\" as a parameter.';\n  }\n\n  function info2(string param) public pure returns (string) {\n    if (keccak256(param) == keccak256(\"hello\")) {\n      return\n        \"The property infoNum holds the number of the next info method to call.\";\n    }\n    return \"Wrong parameter.\";\n  }\n\n  function info42() public pure returns (string) {\n    return \"theMethodName is the name of the next method.\";\n  }\n\n  function method7123949() public pure returns (string) {\n    return \"If you know the password, submit it to authenticate().\";\n  }\n\n  function authenticate(string passkey) public {\n    if (keccak256(passkey) == keccak256(password)) {\n      cleared = true;\n    }\n  }\n\n  function getCleared() public view returns (bool) {\n    return cleared;\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Instance.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Instance.sol",
		"exportedSymbols": {
			"Instance": [
				1820
			]
		},
		"id": 1821,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1718,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:16"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1820,
				"linearizedBaseContracts": [
					1820
				],
				"name": "Instance",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 1720,
						"name": "password",
						"nodeType": "VariableDeclaration",
						"scope": 1820,
						"src": "48:22:16",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_string_storage",
							"typeString": "string"
						},
						"typeName": {
							"id": 1719,
							"name": "string",
							"nodeType": "ElementaryTypeName",
							"src": "48:6:16",
							"typeDescriptions": {
								"typeIdentifier": "t_string_storage_ptr",
								"typeString": "string"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1723,
						"name": "infoNum",
						"nodeType": "VariableDeclaration",
						"scope": 1820,
						"src": "74:25:16",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint8",
							"typeString": "uint8"
						},
						"typeName": {
							"id": 1721,
							"name": "uint8",
							"nodeType": "ElementaryTypeName",
							"src": "74:5:16",
							"typeDescriptions": {
								"typeIdentifier": "t_uint8",
								"typeString": "uint8"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "3432",
							"id": 1722,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "97:2:16",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_42_by_1",
								"typeString": "int_const 42"
							},
							"value": "42"
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1726,
						"name": "theMethodName",
						"nodeType": "VariableDeclaration",
						"scope": 1820,
						"src": "103:65:16",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_string_storage",
							"typeString": "string"
						},
						"typeName": {
							"id": 1724,
							"name": "string",
							"nodeType": "ElementaryTypeName",
							"src": "103:6:16",
							"typeDescriptions": {
								"typeIdentifier": "t_string_storage_ptr",
								"typeString": "string"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "546865206d6574686f64206e616d65206973206d6574686f64373132333934392e",
							"id": 1725,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "string",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "133:35:16",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_stringliteral_2503729b55249c4b028e6f2096d6b89f944fb9a85cc43b0282b5f35806c55069",
								"typeString": "literal_string \"The method name is method7123949.\""
							},
							"value": "The method name is method7123949."
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1729,
						"name": "cleared",
						"nodeType": "VariableDeclaration",
						"scope": 1820,
						"src": "172:28:16",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 1727,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "172:4:16",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "66616c7365",
							"id": 1728,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "bool",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "195:5:16",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							},
							"value": "false"
						},
						"visibility": "private"
					},
					{
						"body": {
							"id": 1738,
							"nodeType": "Block",
							"src": "265:31:16",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1736,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1734,
											"name": "password",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1720,
											"src": "271:8:16",
											"typeDescriptions": {
												"typeIdentifier": "t_string_storage",
												"typeString": "string storage ref"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 1735,
											"name": "_password",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1731,
											"src": "282:9:16",
											"typeDescriptions": {
												"typeIdentifier": "t_string_memory_ptr",
												"typeString": "string memory"
											}
										},
										"src": "271:20:16",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage",
											"typeString": "string storage ref"
										}
									},
									"id": 1737,
									"nodeType": "ExpressionStatement",
									"src": "271:20:16"
								}
							]
						},
						"documentation": null,
						"id": 1739,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "Instance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1732,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1731,
									"name": "_password",
									"nodeType": "VariableDeclaration",
									"scope": 1739,
									"src": "240:16:16",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 1730,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "240:6:16",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "239:18:16"
						},
						"payable": false,
						"returnParameters": {
							"id": 1733,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "265:0:16"
						},
						"scope": 1820,
						"src": "222:74:16",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1746,
							"nodeType": "Block",
							"src": "345:59:16",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "596f752077696c6c2066696e64207768617420796f75206e65656420696e20696e666f3128292e",
										"id": 1744,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "string",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "358:41:16",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_stringliteral_18d33c94a1f5bb5701ef5da354369b4581c035d41d6a326f82d98a41ea642808",
											"typeString": "literal_string \"You will find what you need in info1().\""
										},
										"value": "You will find what you need in info1()."
									},
									"functionReturnParameters": 1743,
									"id": 1745,
									"nodeType": "Return",
									"src": "351:48:16"
								}
							]
						},
						"documentation": null,
						"id": 1747,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "info",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1740,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "313:2:16"
						},
						"payable": false,
						"returnParameters": {
							"id": 1743,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1742,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1747,
									"src": "337:6:16",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 1741,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "337:6:16",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "336:8:16"
						},
						"scope": 1820,
						"src": "300:104:16",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1754,
							"nodeType": "Block",
							"src": "454:65:16",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "54727920696e666f3228292c206275742077697468202268656c6c6f22206173206120706172616d657465722e",
										"id": 1752,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "string",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "467:47:16",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_stringliteral_51dac7487e2d0ffee8bbada3222ae17c9f840227ebf43e11e3b82307a719b75b",
											"typeString": "literal_string \"Try info2(), but with \"hello\" as a parameter.\""
										},
										"value": "Try info2(), but with \"hello\" as a parameter."
									},
									"functionReturnParameters": 1751,
									"id": 1753,
									"nodeType": "Return",
									"src": "460:54:16"
								}
							]
						},
						"documentation": null,
						"id": 1755,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "info1",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1748,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "422:2:16"
						},
						"payable": false,
						"returnParameters": {
							"id": 1751,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1750,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1755,
									"src": "446:6:16",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 1749,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "446:6:16",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "445:8:16"
						},
						"scope": 1820,
						"src": "408:111:16",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1775,
							"nodeType": "Block",
							"src": "581:187:16",
							"statements": [
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										},
										"id": 1768,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1763,
													"name": "param",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1757,
													"src": "601:5:16",
													"typeDescriptions": {
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												],
												"id": 1762,
												"name": "keccak256",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2931,
												"src": "591:9:16",
												"typeDescriptions": {
													"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
													"typeString": "function () pure returns (bytes32)"
												}
											},
											"id": 1764,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "591:16:16",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "68656c6c6f",
													"id": 1766,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "621:7:16",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_1c8aff950685c2ed4bc3174f3472287b56d9517b9c948127319a09a7a36deac8",
														"typeString": "literal_string \"hello\""
													},
													"value": "hello"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_stringliteral_1c8aff950685c2ed4bc3174f3472287b56d9517b9c948127319a09a7a36deac8",
														"typeString": "literal_string \"hello\""
													}
												],
												"id": 1765,
												"name": "keccak256",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2931,
												"src": "611:9:16",
												"typeDescriptions": {
													"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
													"typeString": "function () pure returns (bytes32)"
												}
											},
											"id": 1767,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "611:18:16",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "591:38:16",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 1772,
									"nodeType": "IfStatement",
									"src": "587:146:16",
									"trueBody": {
										"id": 1771,
										"nodeType": "Block",
										"src": "631:102:16",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"hexValue": "5468652070726f706572747920696e666f4e756d20686f6c647320746865206e756d626572206f6620746865206e65787420696e666f206d6574686f6420746f2063616c6c2e",
													"id": 1769,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "654:72:16",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_a26c21bc8ea9f1905c121a3e7c63d5faa421793a4139df3ccd3efa57db938b49",
														"typeString": "literal_string \"The property infoNum holds the number of the next info method to call.\""
													},
													"value": "The property infoNum holds the number of the next info method to call."
												},
												"functionReturnParameters": 1761,
												"id": 1770,
												"nodeType": "Return",
												"src": "639:87:16"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "57726f6e6720706172616d657465722e",
										"id": 1773,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "string",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "745:18:16",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_stringliteral_b601fad3d3d1fbffca394b53af0f91d25155d399b982c8fd7898f7154394e3c2",
											"typeString": "literal_string \"Wrong parameter.\""
										},
										"value": "Wrong parameter."
									},
									"functionReturnParameters": 1761,
									"id": 1774,
									"nodeType": "Return",
									"src": "738:25:16"
								}
							]
						},
						"documentation": null,
						"id": 1776,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "info2",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1758,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1757,
									"name": "param",
									"nodeType": "VariableDeclaration",
									"scope": 1776,
									"src": "538:12:16",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 1756,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "538:6:16",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "537:14:16"
						},
						"payable": false,
						"returnParameters": {
							"id": 1761,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1760,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1776,
									"src": "573:6:16",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 1759,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "573:6:16",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "572:8:16"
						},
						"scope": 1820,
						"src": "523:245:16",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1783,
							"nodeType": "Block",
							"src": "819:65:16",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "7468654d6574686f644e616d6520697320746865206e616d65206f6620746865206e657874206d6574686f642e",
										"id": 1781,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "string",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "832:47:16",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_stringliteral_d3c61225f9e7dd0de370751940991ab402a99f7bbcaf9201287a0b5252a87460",
											"typeString": "literal_string \"theMethodName is the name of the next method.\""
										},
										"value": "theMethodName is the name of the next method."
									},
									"functionReturnParameters": 1780,
									"id": 1782,
									"nodeType": "Return",
									"src": "825:54:16"
								}
							]
						},
						"documentation": null,
						"id": 1784,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "info42",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1777,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "787:2:16"
						},
						"payable": false,
						"returnParameters": {
							"id": 1780,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1779,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1784,
									"src": "811:6:16",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 1778,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "811:6:16",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "810:8:16"
						},
						"scope": 1820,
						"src": "772:112:16",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1791,
							"nodeType": "Block",
							"src": "942:74:16",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "496620796f75206b6e6f77207468652070617373776f72642c207375626d697420697420746f2061757468656e74696361746528292e",
										"id": 1789,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "string",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "955:56:16",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_stringliteral_a43a77889820039a1512b30dd7e1f8d4a6e69caa9b58da067871b4225bd2ef4d",
											"typeString": "literal_string \"If you know the password, submit it to authenticate().\""
										},
										"value": "If you know the password, submit it to authenticate()."
									},
									"functionReturnParameters": 1788,
									"id": 1790,
									"nodeType": "Return",
									"src": "948:63:16"
								}
							]
						},
						"documentation": null,
						"id": 1792,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "method7123949",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1785,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "910:2:16"
						},
						"payable": false,
						"returnParameters": {
							"id": 1788,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1787,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1792,
									"src": "934:6:16",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 1786,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "934:6:16",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "933:8:16"
						},
						"scope": 1820,
						"src": "888:128:16",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1810,
							"nodeType": "Block",
							"src": "1065:86:16",
							"statements": [
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										},
										"id": 1803,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1798,
													"name": "passkey",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1794,
													"src": "1085:7:16",
													"typeDescriptions": {
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												],
												"id": 1797,
												"name": "keccak256",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2931,
												"src": "1075:9:16",
												"typeDescriptions": {
													"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
													"typeString": "function () pure returns (bytes32)"
												}
											},
											"id": 1799,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "1075:18:16",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1801,
													"name": "password",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1720,
													"src": "1107:8:16",
													"typeDescriptions": {
														"typeIdentifier": "t_string_storage",
														"typeString": "string storage ref"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_string_storage",
														"typeString": "string storage ref"
													}
												],
												"id": 1800,
												"name": "keccak256",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2931,
												"src": "1097:9:16",
												"typeDescriptions": {
													"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
													"typeString": "function () pure returns (bytes32)"
												}
											},
											"id": 1802,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "1097:19:16",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "1075:41:16",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 1809,
									"nodeType": "IfStatement",
									"src": "1071:76:16",
									"trueBody": {
										"id": 1808,
										"nodeType": "Block",
										"src": "1118:29:16",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 1806,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 1804,
														"name": "cleared",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1729,
														"src": "1126:7:16",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "74727565",
														"id": 1805,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "bool",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "1136:4:16",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"value": "true"
													},
													"src": "1126:14:16",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"id": 1807,
												"nodeType": "ExpressionStatement",
												"src": "1126:14:16"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 1811,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "authenticate",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1795,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1794,
									"name": "passkey",
									"nodeType": "VariableDeclaration",
									"scope": 1811,
									"src": "1042:14:16",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 1793,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "1042:6:16",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1041:16:16"
						},
						"payable": false,
						"returnParameters": {
							"id": 1796,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1065:0:16"
						},
						"scope": 1820,
						"src": "1020:131:16",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1818,
							"nodeType": "Block",
							"src": "1204:25:16",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1816,
										"name": "cleared",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1729,
										"src": "1217:7:16",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 1815,
									"id": 1817,
									"nodeType": "Return",
									"src": "1210:14:16"
								}
							]
						},
						"documentation": null,
						"id": 1819,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getCleared",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1812,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1174:2:16"
						},
						"payable": false,
						"returnParameters": {
							"id": 1815,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1814,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1819,
									"src": "1198:4:16",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1813,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "1198:4:16",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1197:6:16"
						},
						"scope": 1820,
						"src": "1155:74:16",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 1821,
				"src": "26:1205:16"
			}
		],
		"src": "0:1232:16"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Instance.sol",
		"exportedSymbols": {
			"Instance": [
				1820
			]
		},
		"id": 1821,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1718,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:16"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1820,
				"linearizedBaseContracts": [
					1820
				],
				"name": "Instance",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 1720,
						"name": "password",
						"nodeType": "VariableDeclaration",
						"scope": 1820,
						"src": "48:22:16",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_string_storage",
							"typeString": "string"
						},
						"typeName": {
							"id": 1719,
							"name": "string",
							"nodeType": "ElementaryTypeName",
							"src": "48:6:16",
							"typeDescriptions": {
								"typeIdentifier": "t_string_storage_ptr",
								"typeString": "string"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1723,
						"name": "infoNum",
						"nodeType": "VariableDeclaration",
						"scope": 1820,
						"src": "74:25:16",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint8",
							"typeString": "uint8"
						},
						"typeName": {
							"id": 1721,
							"name": "uint8",
							"nodeType": "ElementaryTypeName",
							"src": "74:5:16",
							"typeDescriptions": {
								"typeIdentifier": "t_uint8",
								"typeString": "uint8"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "3432",
							"id": 1722,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "97:2:16",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_42_by_1",
								"typeString": "int_const 42"
							},
							"value": "42"
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1726,
						"name": "theMethodName",
						"nodeType": "VariableDeclaration",
						"scope": 1820,
						"src": "103:65:16",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_string_storage",
							"typeString": "string"
						},
						"typeName": {
							"id": 1724,
							"name": "string",
							"nodeType": "ElementaryTypeName",
							"src": "103:6:16",
							"typeDescriptions": {
								"typeIdentifier": "t_string_storage_ptr",
								"typeString": "string"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "546865206d6574686f64206e616d65206973206d6574686f64373132333934392e",
							"id": 1725,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "string",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "133:35:16",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_stringliteral_2503729b55249c4b028e6f2096d6b89f944fb9a85cc43b0282b5f35806c55069",
								"typeString": "literal_string \"The method name is method7123949.\""
							},
							"value": "The method name is method7123949."
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1729,
						"name": "cleared",
						"nodeType": "VariableDeclaration",
						"scope": 1820,
						"src": "172:28:16",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 1727,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "172:4:16",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "66616c7365",
							"id": 1728,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "bool",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "195:5:16",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							},
							"value": "false"
						},
						"visibility": "private"
					},
					{
						"body": {
							"id": 1738,
							"nodeType": "Block",
							"src": "265:31:16",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1736,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1734,
											"name": "password",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1720,
											"src": "271:8:16",
											"typeDescriptions": {
												"typeIdentifier": "t_string_storage",
												"typeString": "string storage ref"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 1735,
											"name": "_password",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1731,
											"src": "282:9:16",
											"typeDescriptions": {
												"typeIdentifier": "t_string_memory_ptr",
												"typeString": "string memory"
											}
										},
										"src": "271:20:16",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage",
											"typeString": "string storage ref"
										}
									},
									"id": 1737,
									"nodeType": "ExpressionStatement",
									"src": "271:20:16"
								}
							]
						},
						"documentation": null,
						"id": 1739,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "Instance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1732,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1731,
									"name": "_password",
									"nodeType": "VariableDeclaration",
									"scope": 1739,
									"src": "240:16:16",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 1730,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "240:6:16",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "239:18:16"
						},
						"payable": false,
						"returnParameters": {
							"id": 1733,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "265:0:16"
						},
						"scope": 1820,
						"src": "222:74:16",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1746,
							"nodeType": "Block",
							"src": "345:59:16",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "596f752077696c6c2066696e64207768617420796f75206e65656420696e20696e666f3128292e",
										"id": 1744,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "string",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "358:41:16",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_stringliteral_18d33c94a1f5bb5701ef5da354369b4581c035d41d6a326f82d98a41ea642808",
											"typeString": "literal_string \"You will find what you need in info1().\""
										},
										"value": "You will find what you need in info1()."
									},
									"functionReturnParameters": 1743,
									"id": 1745,
									"nodeType": "Return",
									"src": "351:48:16"
								}
							]
						},
						"documentation": null,
						"id": 1747,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "info",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1740,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "313:2:16"
						},
						"payable": false,
						"returnParameters": {
							"id": 1743,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1742,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1747,
									"src": "337:6:16",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 1741,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "337:6:16",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "336:8:16"
						},
						"scope": 1820,
						"src": "300:104:16",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1754,
							"nodeType": "Block",
							"src": "454:65:16",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "54727920696e666f3228292c206275742077697468202268656c6c6f22206173206120706172616d657465722e",
										"id": 1752,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "string",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "467:47:16",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_stringliteral_51dac7487e2d0ffee8bbada3222ae17c9f840227ebf43e11e3b82307a719b75b",
											"typeString": "literal_string \"Try info2(), but with \"hello\" as a parameter.\""
										},
										"value": "Try info2(), but with \"hello\" as a parameter."
									},
									"functionReturnParameters": 1751,
									"id": 1753,
									"nodeType": "Return",
									"src": "460:54:16"
								}
							]
						},
						"documentation": null,
						"id": 1755,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "info1",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1748,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "422:2:16"
						},
						"payable": false,
						"returnParameters": {
							"id": 1751,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1750,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1755,
									"src": "446:6:16",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 1749,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "446:6:16",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "445:8:16"
						},
						"scope": 1820,
						"src": "408:111:16",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1775,
							"nodeType": "Block",
							"src": "581:187:16",
							"statements": [
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										},
										"id": 1768,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1763,
													"name": "param",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1757,
													"src": "601:5:16",
													"typeDescriptions": {
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												],
												"id": 1762,
												"name": "keccak256",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2931,
												"src": "591:9:16",
												"typeDescriptions": {
													"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
													"typeString": "function () pure returns (bytes32)"
												}
											},
											"id": 1764,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "591:16:16",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "68656c6c6f",
													"id": 1766,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "621:7:16",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_1c8aff950685c2ed4bc3174f3472287b56d9517b9c948127319a09a7a36deac8",
														"typeString": "literal_string \"hello\""
													},
													"value": "hello"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_stringliteral_1c8aff950685c2ed4bc3174f3472287b56d9517b9c948127319a09a7a36deac8",
														"typeString": "literal_string \"hello\""
													}
												],
												"id": 1765,
												"name": "keccak256",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2931,
												"src": "611:9:16",
												"typeDescriptions": {
													"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
													"typeString": "function () pure returns (bytes32)"
												}
											},
											"id": 1767,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "611:18:16",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "591:38:16",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 1772,
									"nodeType": "IfStatement",
									"src": "587:146:16",
									"trueBody": {
										"id": 1771,
										"nodeType": "Block",
										"src": "631:102:16",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"hexValue": "5468652070726f706572747920696e666f4e756d20686f6c647320746865206e756d626572206f6620746865206e65787420696e666f206d6574686f6420746f2063616c6c2e",
													"id": 1769,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "654:72:16",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_a26c21bc8ea9f1905c121a3e7c63d5faa421793a4139df3ccd3efa57db938b49",
														"typeString": "literal_string \"The property infoNum holds the number of the next info method to call.\""
													},
													"value": "The property infoNum holds the number of the next info method to call."
												},
												"functionReturnParameters": 1761,
												"id": 1770,
												"nodeType": "Return",
												"src": "639:87:16"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "57726f6e6720706172616d657465722e",
										"id": 1773,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "string",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "745:18:16",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_stringliteral_b601fad3d3d1fbffca394b53af0f91d25155d399b982c8fd7898f7154394e3c2",
											"typeString": "literal_string \"Wrong parameter.\""
										},
										"value": "Wrong parameter."
									},
									"functionReturnParameters": 1761,
									"id": 1774,
									"nodeType": "Return",
									"src": "738:25:16"
								}
							]
						},
						"documentation": null,
						"id": 1776,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "info2",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1758,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1757,
									"name": "param",
									"nodeType": "VariableDeclaration",
									"scope": 1776,
									"src": "538:12:16",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 1756,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "538:6:16",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "537:14:16"
						},
						"payable": false,
						"returnParameters": {
							"id": 1761,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1760,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1776,
									"src": "573:6:16",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 1759,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "573:6:16",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "572:8:16"
						},
						"scope": 1820,
						"src": "523:245:16",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1783,
							"nodeType": "Block",
							"src": "819:65:16",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "7468654d6574686f644e616d6520697320746865206e616d65206f6620746865206e657874206d6574686f642e",
										"id": 1781,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "string",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "832:47:16",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_stringliteral_d3c61225f9e7dd0de370751940991ab402a99f7bbcaf9201287a0b5252a87460",
											"typeString": "literal_string \"theMethodName is the name of the next method.\""
										},
										"value": "theMethodName is the name of the next method."
									},
									"functionReturnParameters": 1780,
									"id": 1782,
									"nodeType": "Return",
									"src": "825:54:16"
								}
							]
						},
						"documentation": null,
						"id": 1784,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "info42",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1777,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "787:2:16"
						},
						"payable": false,
						"returnParameters": {
							"id": 1780,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1779,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1784,
									"src": "811:6:16",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 1778,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "811:6:16",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "810:8:16"
						},
						"scope": 1820,
						"src": "772:112:16",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1791,
							"nodeType": "Block",
							"src": "942:74:16",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "496620796f75206b6e6f77207468652070617373776f72642c207375626d697420697420746f2061757468656e74696361746528292e",
										"id": 1789,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "string",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "955:56:16",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_stringliteral_a43a77889820039a1512b30dd7e1f8d4a6e69caa9b58da067871b4225bd2ef4d",
											"typeString": "literal_string \"If you know the password, submit it to authenticate().\""
										},
										"value": "If you know the password, submit it to authenticate()."
									},
									"functionReturnParameters": 1788,
									"id": 1790,
									"nodeType": "Return",
									"src": "948:63:16"
								}
							]
						},
						"documentation": null,
						"id": 1792,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "method7123949",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1785,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "910:2:16"
						},
						"payable": false,
						"returnParameters": {
							"id": 1788,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1787,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1792,
									"src": "934:6:16",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 1786,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "934:6:16",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "933:8:16"
						},
						"scope": 1820,
						"src": "888:128:16",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1810,
							"nodeType": "Block",
							"src": "1065:86:16",
							"statements": [
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										},
										"id": 1803,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1798,
													"name": "passkey",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1794,
													"src": "1085:7:16",
													"typeDescriptions": {
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												],
												"id": 1797,
												"name": "keccak256",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2931,
												"src": "1075:9:16",
												"typeDescriptions": {
													"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
													"typeString": "function () pure returns (bytes32)"
												}
											},
											"id": 1799,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "1075:18:16",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1801,
													"name": "password",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1720,
													"src": "1107:8:16",
													"typeDescriptions": {
														"typeIdentifier": "t_string_storage",
														"typeString": "string storage ref"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_string_storage",
														"typeString": "string storage ref"
													}
												],
												"id": 1800,
												"name": "keccak256",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2931,
												"src": "1097:9:16",
												"typeDescriptions": {
													"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
													"typeString": "function () pure returns (bytes32)"
												}
											},
											"id": 1802,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "1097:19:16",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "1075:41:16",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 1809,
									"nodeType": "IfStatement",
									"src": "1071:76:16",
									"trueBody": {
										"id": 1808,
										"nodeType": "Block",
										"src": "1118:29:16",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 1806,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 1804,
														"name": "cleared",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1729,
														"src": "1126:7:16",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "74727565",
														"id": 1805,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "bool",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "1136:4:16",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"value": "true"
													},
													"src": "1126:14:16",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"id": 1807,
												"nodeType": "ExpressionStatement",
												"src": "1126:14:16"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 1811,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "authenticate",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1795,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1794,
									"name": "passkey",
									"nodeType": "VariableDeclaration",
									"scope": 1811,
									"src": "1042:14:16",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 1793,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "1042:6:16",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1041:16:16"
						},
						"payable": false,
						"returnParameters": {
							"id": 1796,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1065:0:16"
						},
						"scope": 1820,
						"src": "1020:131:16",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1818,
							"nodeType": "Block",
							"src": "1204:25:16",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1816,
										"name": "cleared",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1729,
										"src": "1217:7:16",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 1815,
									"id": 1817,
									"nodeType": "Return",
									"src": "1210:14:16"
								}
							]
						},
						"documentation": null,
						"id": 1819,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getCleared",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1812,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1174:2:16"
						},
						"payable": false,
						"returnParameters": {
							"id": 1815,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1814,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1819,
									"src": "1198:4:16",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1813,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "1198:4:16",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1197:6:16"
						},
						"scope": 1820,
						"src": "1155:74:16",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 1821,
				"src": "26:1205:16"
			}
		],
		"src": "0:1232:16"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.805Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/Instance.json
// module id = 1043
// module chunks = 0